import { Checkbox as BaseCheckbox } from '@base-ui/react/checkbox';
import type { ComponentProps } from 'react';
import { CheckIcon, MinusIcon } from '../lib/icons.tsx';
import { cx } from '../lib/styled.tsx';

export type CheckboxProps = ComponentProps<typeof BaseCheckbox.Root>;

/**
 * Box + indicator in one component. The indicator swaps to a dash while
 * `indeterminate` is set, which is the only state it has to decide for itself.
 */
export function Checkbox({ className, ...props }: CheckboxProps) {
  return (
    <BaseCheckbox.Root
      className={cx(
        'flex size-[18px] shrink-0 items-center justify-center rounded-xs',
        'border-2 border-ink-dim bg-surface-raised text-surface-raised',
        'transition-[background-color,border-color] duration-150 ease-out-quint',
        'data-checked:border-brand-600 data-checked:bg-brand-600',
        'data-indeterminate:border-brand-600 data-indeterminate:bg-brand-600',
        'data-invalid:border-danger',
        'data-disabled:cursor-not-allowed data-disabled:border-ink-faint data-disabled:bg-border-subtle',
        className,
      )}
      {...props}
    >
      <BaseCheckbox.Indicator className="flex data-unchecked:hidden">
        {props.indeterminate ? <MinusIcon className="size-3" /> : <CheckIcon className="size-3" />}
      </BaseCheckbox.Indicator>
    </BaseCheckbox.Root>
  );
}
